<div class="page-contents" style="background: #E5E5E5">
    <div [ngClass]="{'blockContainer': !setFullWindow , 'levelOne-full-container':setFullWindow}" id='levelOne'
      style="border-right: 0">
      <div class="pageTitle">
        {{title}}
        <i class="material-icons pullfloat-right" [routerLink]="['/home']">close</i>
          <i class="material-icons pullfloat-right" *ngIf="!component || component.hostView.destroyed" (click)="setFullWindow = !setFullWindow">
          {{setFullWindow?'photo_size_select_small':'fullscreen'}}
        </i>
      </div>
      
      <div class="menuBlock">
        <ul class="list-group list-group-flush" *ngFor="let tag of tags">           
          <li class="list-group-item" [routerLink]="['tag', tag]">
            <i class="fas" [class]="'far fa-circle'"></i>
            &nbsp;&nbsp;{{tag}} </li>
        </ul>
      </div>
    </div>
    <div class="entry-container" style="background: transparent" id="cmsView">
      <router-outlet></router-outlet>
    </div>
  </div>